/**
 * SQL Dashboards feature module — registers the `dashboard` workspace type.
 * See Docs/Dashboards.md for the architecture overview.
 */
import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { DashboardTab } from './components/DashboardTab';

registerWorkspaceComponent('dashboard', DashboardTab);

export { DashboardTab } from './components/DashboardTab';
export { openDashboardTab } from './utils/openDashboardTab';
export { useDashboardStore, initDashboardStoreBridge } from './store/dashboardStore';
